import { useCustomThemeDraftState } from '@olo-web/client-state';
import { useMerchantTheme, useMerchantGroup, useMerchant } from '@domain/merchants/queries';
const spotOnFaviconUrl =
  'https://firebasestorage.googleapis.com/v0/b/android-spoton-mobile-192322.appspot.com/o/favicon-32x32.png?alt=media&token=24ab335c-dcba-406f-bc60-7f0115cc381b';

export const useMerchantImages = () => {
  const { data: theme } = useMerchantTheme();
  const { data: group } = useMerchantGroup();
  const { data: merchant } = useMerchant();
  const { logoUrl, backgroundUrl, faviconUrl } = useCustomThemeDraftState();

  const merchantDisplayName = merchant?.name || group?.name || '';

  return {
    logoUrl: logoUrl || theme?.logoUrl || group?.logoUrl || group?.mobileBackgroundUrl,
    logoAlt: merchantDisplayName,
    backgroundUrl: backgroundUrl || theme?.backgroundUrl || group?.backgroundUrl,
    backgroundAlt: merchantDisplayName,
    faviconUrl:
      faviconUrl || theme?.faviconUrl || theme?.logoUrl || group?.logoUrl || spotOnFaviconUrl,
  };
};
